function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 12a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm3-3a1 1 0 110 2 1 1 0 010-2zM1 9a1 1 0 110 2 1 1 0 010-2zm0-3a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zm0-3a1 1 0 110 2 1 1 0 010-2zM1 3a1 1 0 110 2 1 1 0 010-2zm0-3a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2z",
  fill: "#C1C8D2",
  fillRule: "evenodd"
});

const SvgHandle = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 5,
  height: 14,
  viewBox: "0 0 5 14",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHandle, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;